import DeepAnalysisSectionHeader from './DeepAnalysisSectionHeader'

/**
 * Numbered "Resultaat" section card at the top of a deep-analysis page
 * (redesign). Wraps the entity's visualisation card body.
 *
 * @param {object} props
 * @param {string} [props.title] - Section title (default 'Gemeten resultaat')
 * @param {string} [props.description] - Explainer under the title
 * @param {React.ReactNode} props.children - The analysis card (with a passthrough frame)
 */
const DeepAnalysisResultSection = ({
    title = 'Gemeten resultaat',
    description = 'De gemiddelde score per meetmoment, over alle deelnemers binnen de gekozen weergave.',
    children,
}) => {
    return (
        <div className='deep-analysis-section deep-analysis-result-section'>
            <DeepAnalysisSectionHeader
                kicker='Resultaat'
                title={title}
                description={description}
            />
            {children}
        </div>
    )
}

export default DeepAnalysisResultSection
